import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'assets/icons/back.svg';
type BackButtonColor = 'red' | 'gray';

const BackButton = ({
  link,
  text = 'Back',
  color = 'gray'
}: {
  link?: string;
  text?: string;
  color?: BackButtonColor;
}) => {
  const navigate = useNavigate();
  const goBack = () => {
    if (link) {
      navigate(link);
    } else {
      navigate(-1);
    }
  };
  return (
    <div
      className={`cursor-pointer flex gap-2 items-center text-pink-8 text-sm font-medium mb-3 ${
        color === 'gray' ? 'text-gray-8' : color === 'red' && 'text-red-5'
      }`}
      onClick={goBack}>
      <BackIcon />
      <span>{text}</span>
    </div>
  );
};

export default BackButton;
